import React from 'react';
import { CtaButton } from './CtaButton';
import { PriceBlock } from './PriceBlock';
import { TrustStrip } from './TrustStrip';
import { PRODUCT } from '../data/poolContent';
export function MidPageCta() {
  return <section className="w-full border-y border-aqua/20 bg-navy py-14 sm:py-16" aria-labelledby="mid-cta-title" data-id="element-210" data-mp="3kmyegswr2sz">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-211" data-mp="8hwv8himmgqu">
        <h2 id="mid-cta-title" className="font-display text-[2rem] font-bold uppercase leading-none text-frost-50 sm:text-[2.7rem]" data-id="element-212" data-mp="37ylh414ioj10">
          The next time your pool changes, don’t start by guessing.
        </h2>
        <p className="mt-3 font-display text-[1.4rem] font-semibold uppercase text-aqua sm:text-[1.7rem]" data-id="element-213" data-mp="3gx6xbpminlym">
          Start by knowing what to check.
        </p>

        <div className="mx-auto mt-8 max-w-md border-t border-pool/25 pt-6" data-id="element-214" data-mp="w77q5idapgx2">
          <p className="font-display text-xl font-bold uppercase tracking-[0.04em] text-frost-50" data-id="element-215" data-mp="116ueonykqjl6">
            {PRODUCT}
          </p>
          <p className="mt-1 text-[13px] text-frost-200" data-id="element-216" data-mp="1cealyik9z5zx">90-page main guide + 4 practical bonuses.</p>
          <PriceBlock className="mt-5" data-id="element-217" data-mp="18ei75o4ag3m4" />
        </div>

        <div className="mt-6 flex justify-center" data-id="element-218" data-mp="13enh1msc7i24">
          <CtaButton size="md" label="I Want My Pool Answer Guide →" data-id="element-219" data-mp="13dcfltmd6me6" />
        </div>
        <TrustStrip className="mt-4" data-id="element-220" data-mp="yf14lfkc25ud" />
      </div>
    </section>;
}